<template>
  <div :class="classes">
    <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber" @size-change="handleSizeChange" :pageSizes="[10,15, 20,25, 30, 50,150,1000]" layout='total, sizes, prev, pager, next, jumper' :page-size="pageSize" :refresh="true" ref="table">
      <handle-table v-bind="$attrs" v-on="$listeners" ref="handleTabel" :status="status">
        <slot />
      </handle-table>
    </wt-paged-table>
  </div>
</template>

<script>
import handleTable from './handle-table'
// 组件class前缀
const prefixCls = 'pt-order-handle-table'

export default {
  name: 'pt-order-handle-table',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    page () {
      return this.$refs.table.page
    }
  },
  components: { handleTable },
  props: {
    totalNumber: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 0
    },
    requestData: {
      type: Function
    },
    status: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      selected: []
    }
  },
  methods: {
    handleSizeChange (val) {
      this.$refs.handleTabel.clearSelection()
      this.$emit('size-change', val)
    },
    resetPage () {
      this.$refs.table.resetPage()
      this.$refs.handleTabel.clearSelection()
    },
    getTableData (page, next) {
      this.requestData && this.requestData(page, next)
    },
    reload () {
      this.$refs.table.load()
    },
    showReTry () {
      this.$refs.table.showReTry()
    },
    updateSelected (row) {
      this.$refs.handleTabel.handleDeleteDatas([row])
    },
    clearSelection () {
      this.$refs.handleTabel.clearSelection()
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
</style>
